import BaseRequest from './index'

import {
  LoginDto,
  SignupDto,
  VerifyEmailDto,
  VerifyEmailData,
  Payload,
  SignupData,
  LoginData,
  VerifyphoneNumberDto,
  VerifyphoneNumberData,
} from './types'

class AuthService extends BaseRequest {
  constructor() {
    super()
    this.bindMethods()
  }

  bindMethods() {
    this.login = this.login.bind(this)
    this.register = this.register.bind(this)
    this.forgotPassword = this.forgotPassword.bind(this)
    this.verifyToken = this.verifyToken.bind(this)
    this.resetPassword = this.resetPassword.bind(this)
    this.verifyEmail = this.verifyEmail.bind(this)
    this.verifyPhoneNumber = this.verifyPhoneNumber.bind(this)
    this.searchUser = this.searchUser.bind(this)
  }

  async login(data: LoginDto) {
    return await this.api.post<Payload<LoginData>>('/user/login', data)
  }
  async searchUser<T>(data: any): Promise<T> {
    return await this.api.post('user/search', data)
  }
  async register(data: SignupDto) {
    return await this.api.post<Payload<SignupData>>('/user/register', data)
  }
  async verifyEmail(data: VerifyEmailDto) {
    return await this.api.post<Payload<VerifyEmailData>>('/user/email', data)
  }
  async verifyPhoneNumber(data: VerifyphoneNumberDto) {
    return await this.api.post<Payload<VerifyphoneNumberData>>(
      '/user/phone',
      data
    )
  }

  async forgotPassword<T>(email: string): Promise<T> {
    return await this.api.post('/user/password/forgot', email)
  }

  async verifyToken<T>(code: string): Promise<T> {
    return await this.api.post('/user/password/reset/verify-token', code)
  }
  async verifyAccount<T>(): Promise<T> {
    return await this.api.get('/user/account/verify')
  }
  async resetPassword<T>(data: any): Promise<T> {
    return await this.api.put('/user/password/reset', data)
  }
}

const authService = new AuthService()

export default authService
